// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.docs-component-body-content {
    display: flex;
    flex: 1 1 auto;
  }
  
.docs-component-viewer-nav {
    position: sticky;
    top: 25px;
}
.docs-component-viewer-nav .docs-component-viewer-nav-content {
  margin: 25px;
  width: 300px;
  max-height: 75vh;
  overflow: auto;
  border-radius: 20px;
}
.docs-component-viewer-nav .docs-component-viewer-nav-content::-webkit-scrollbar {
  height: 4px;
  width: 4px;
}

.section-title {
  font-weight: 700;
  padding-left: 15px;
  font-family: "garamond";
  color: black
}
.section-button {
  margin-right: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  font-weight: 700;
  line-height: 16px;
  font-size: 10px;
  cursor: pointer;
  position: relative;
  display: block;
  width: 80%;
  background: none;
  border:none;
  /* border: 1px solid black; */
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}

.section-button:hover {
  background-color: rgba(0, 0, 0, 0.1)
}

.section-button:focus {
  outline: none;
}
/* .docs-component-viewer-nav .docs-component-viewer-nav-content button .mat-icon {
  position: absolute;
  right: 5px;
  font-size: 18px;
} */
.docs-component-viewer-nav .docs-component-viewer-nav-content hr {
  padding: 0;
  margin: 0;
}
.docs-component-viewer-nav .docs-component-viewer-nav-content ul {
  list-style-type: none;
  margin: 0 0 5px 0;
  padding: 0;
  overflow: hidden;
}
.docs-component-viewer-nav .docs-component-viewer-nav-content li {
  font-size: 13px;
  line-height: 16px;
  margin: 0;
  padding: 5px 15px 5px 20px;
  
}
.docs-component-viewer-nav .docs-component-viewer-nav-content a {
  display: block;
  text-decoration: none;
}
.docs-component-viewer-nav-content {
  background: rgba(0, 0, 0, 0.03);
}
.docs-component-viewer-nav-content::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.26);
}
.docs-component-viewer-nav-content .docs-nav-content-btn {
  color: #737373;
}
.docs-component-viewer-nav-content .docs-nav-content-btn:focus {
  background: rgba(0, 0, 0, 0.08);
}
.docs-component-viewer-nav-content hr {
  border: none;
  border-top: solid 1px rgba(117, 117, 117, 0.1);
}
.docs-component-viewer-nav-content a {
  color: #757575;
}
.docs-component-viewer-nav-content a:hover {
  color: #336699;
  cursor: pointer;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.section-title {
  text-align: center;
}
.section-container {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 20px;
}
.section-container-1 {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 20px;
  height: 40px;
  overflow: hidden;
  border: 3px solid rgba(99, 99, 99, 0.4);
  margin-bottom: 10px;
}

.section-container-1 button {
  width: 100%;
  height: 100%;
  border: none;
  padding: none;
  height:40px;
  background-color: #9fa4c4;
  background-image: linear-gradient(315deg, #b3cdd1 0%, #9fa4c4 74%);
  color: white
}

.section-container-1 button:hover {
  background-color: #b3cdd1;
  background-image: linear-gradient(315deg, #9fa4c4 0%, #b3cdd1 74%);
}

.input-area {
  height: 45px;
  padding-left: 10px;
  justify-content: space-between;
  margin-bottom: 25px;
}

.new-section-input {
  height: 25px;
  width: 180px;
  padding-left: 10px;
  margin-right: 10px;
  border: none;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.title-button-container {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.help-content {
  width: 75%;
  padding: 20px;
  margin-bottom: 20px;
}

.remove-sub-section {
  position: absolute;
  margin-top: 50px;
  left: 50%;
}

`, "",{"version":3,"sources":["webpack://./src/app/help/help.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;EAChB;;AAEF;IACI,gBAAgB;IAChB,SAAS;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB;AACF;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;AACf;AACA;;;;GAIG;AACH;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,0BAA0B;;AAE5B;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,8CAA8C;AAChD;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iDAAiD;EACjD,mBAAmB;AACrB;AACA;EACE,iDAAiD;EACjD,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,kEAAkE;EAClE;AACF;;AAEA;EACE,yBAAyB;EACzB,kEAAkE;AACpE;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,yFAAyF;AAC3F;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX","sourcesContent":[".docs-component-body-content {\n    display: flex;\n    flex: 1 1 auto;\n  }\n  \n.docs-component-viewer-nav {\n    position: sticky;\n    top: 25px;\n}\n.docs-component-viewer-nav .docs-component-viewer-nav-content {\n  margin: 25px;\n  width: 300px;\n  max-height: 75vh;\n  overflow: auto;\n  border-radius: 20px;\n}\n.docs-component-viewer-nav .docs-component-viewer-nav-content::-webkit-scrollbar {\n  height: 4px;\n  width: 4px;\n}\n\n.section-title {\n  font-weight: 700;\n  padding-left: 15px;\n  font-family: \"garamond\";\n  color: black\n}\n.section-button {\n  margin-right: 5px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  font-weight: 700;\n  line-height: 16px;\n  font-size: 10px;\n  cursor: pointer;\n  position: relative;\n  display: block;\n  width: 80%;\n  background: none;\n  border:none;\n  /* border: 1px solid black; */\n  border-radius: 10px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\n}\n\n.section-button:hover {\n  background-color: rgba(0, 0, 0, 0.1)\n}\n\n.section-button:focus {\n  outline: none;\n}\n/* .docs-component-viewer-nav .docs-component-viewer-nav-content button .mat-icon {\n  position: absolute;\n  right: 5px;\n  font-size: 18px;\n} */\n.docs-component-viewer-nav .docs-component-viewer-nav-content hr {\n  padding: 0;\n  margin: 0;\n}\n.docs-component-viewer-nav .docs-component-viewer-nav-content ul {\n  list-style-type: none;\n  margin: 0 0 5px 0;\n  padding: 0;\n  overflow: hidden;\n}\n.docs-component-viewer-nav .docs-component-viewer-nav-content li {\n  font-size: 13px;\n  line-height: 16px;\n  margin: 0;\n  padding: 5px 15px 5px 20px;\n  \n}\n.docs-component-viewer-nav .docs-component-viewer-nav-content a {\n  display: block;\n  text-decoration: none;\n}\n.docs-component-viewer-nav-content {\n  background: rgba(0, 0, 0, 0.03);\n}\n.docs-component-viewer-nav-content::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.26);\n}\n.docs-component-viewer-nav-content .docs-nav-content-btn {\n  color: #737373;\n}\n.docs-component-viewer-nav-content .docs-nav-content-btn:focus {\n  background: rgba(0, 0, 0, 0.08);\n}\n.docs-component-viewer-nav-content hr {\n  border: none;\n  border-top: solid 1px rgba(117, 117, 117, 0.1);\n}\n.docs-component-viewer-nav-content a {\n  color: #757575;\n}\n.docs-component-viewer-nav-content a:hover {\n  color: #336699;\n  cursor: pointer;\n}\n\n.center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.section-title {\n  text-align: center;\n}\n.section-container {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n  border-radius: 20px;\n}\n.section-container-1 {\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n  border-radius: 20px;\n  height: 40px;\n  overflow: hidden;\n  border: 3px solid rgba(99, 99, 99, 0.4);\n  margin-bottom: 10px;\n}\n\n.section-container-1 button {\n  width: 100%;\n  height: 100%;\n  border: none;\n  padding: none;\n  height:40px;\n  background-color: #9fa4c4;\n  background-image: linear-gradient(315deg, #b3cdd1 0%, #9fa4c4 74%);\n  color: white\n}\n\n.section-container-1 button:hover {\n  background-color: #b3cdd1;\n  background-image: linear-gradient(315deg, #9fa4c4 0%, #b3cdd1 74%);\n}\n\n.input-area {\n  height: 45px;\n  padding-left: 10px;\n  justify-content: space-between;\n  margin-bottom: 25px;\n}\n\n.new-section-input {\n  height: 25px;\n  width: 180px;\n  padding-left: 10px;\n  margin-right: 10px;\n  border: none;\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;\n}\n\n.title-button-container {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n}\n\n.help-content {\n  width: 75%;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.remove-sub-section {\n  position: absolute;\n  margin-top: 50px;\n  left: 50%;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
